import React from 'react';
import { Image } from '@lt/components';

import type { IHeaderBanner } from '../types';
import { HEADER_BANNER_DESKTOP_DATA_TEST_ID } from '../constants';
import styles from './headerBanner.module.css';

export const DesktopHeaderBanner = (props: IHeaderBanner): JSX.Element => {
  const { desktopText, imageSrc } = props;

  return (
    <div
      className={styles.desktopContainer}
      data-testid={HEADER_BANNER_DESKTOP_DATA_TEST_ID}
    >
      {!!imageSrc && (
        <div className={styles.imageWrapper}>
          <Image
            className={styles.image}
            src={imageSrc.webp_x30x30}
            fallback={imageSrc.x30x30}
          />
        </div>
      )}
      <div className={styles.textWrapper}>
        <span className={styles.text}>{desktopText}</span>
      </div>
    </div>
  );
};
